<template>
  <div
    class="content-wrapper"
    :class="{
      'content-wrapper--light': background === 'light',
      'content-wrapper--padded': addPadding
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "ContentWrapper",
  props: {
    background: {
      default: "dark",
      type: String
    },
    addPadding: {
      default: true,
      type: Boolean
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variables.scss";

.content-wrapper--light {
  background-color: $color-dark-lighter;
}

.content-wrapper {
  background-color: $color-dark;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-radius: 0 $border-radius $border-radius $border-radius;
  border: 2px solid #ededed;
  margin-bottom: $margin;
  margin-left: $margin;
  margin-right: $margin;
}

.content-wrapper--padded > * {
  padding-left: 10px;
  padding-right: 10px;
}

@media (max-width: 767px) {
  .content-wrapper {
    flex-grow: 1;
    flex-direction: column;
    border-top: 0;
    border-radius: 0 0 $border-radius $border-radius;
  }
}
</style>
